import { constants as dateAndTimeConstants } from 'utils/dateAndTimes';
import { constants as addressesConstants } from 'utils/addresses';
import { setTime } from 'utils/dateAndTimes/methods/methods';
import moment from 'moment-timezone';
import { validationSchemaForDirect } from 'state/direct-order/validationSchema';

const getTimeKeyFull = (shipmentKey, key) => `shipment.${shipmentKey}.${key}`;
const getTimeKey = (stopType, timeParam) => `${stopType}_${timeParam}`;

const getDateKey = (stopType, timeParam) =>
  `${stopType}_date_${timeParam.split('_')[1]}`;
const getDateFromKey = (stopType) => `${stopType}_date_from`;
const getDateToKey = (stopType) => `${stopType}_date_to`;

const getDateKeys = (stopType) => [
  getDateFromKey(stopType),
  getDateToKey(stopType),
];

const getTimeKeysByStop = (stopType) => [
  `${stopType}_${dateAndTimeConstants.TIME_FIELD_PARAMS.from}`,
  `${stopType}_${dateAndTimeConstants.TIME_FIELD_PARAMS.to}`,
];

const getAddressKey = (stopType) =>
  addressesConstants.ADDRESS_BY_STOP[stopType];
const getAddressRawKey = (stopType) =>
  `${addressesConstants.ADDRESS_BY_STOP[stopType]}_raw`;

const getWorkingDayHours = (times) => {
  if (!Array.isArray(times)) {
    return { from: 8, to: 18 };
  }
  const [from, to] = times;
  const [fromHour, fromMinute] = from.split(':');
  const [toHour, toMinute] = to.split(':');

  return {
    from: from.length === 5 ? from : `0${from}`,
    to: to.length === 5 ? to : `0${to}`,
    fromHour,
    fromMinute,
    toHour,
    toMinute,
  };
};

const getGenericDefaultDates = (originalTimes) => {
  // This should be replaced with validations when offering validations for DIRECT / TODAY
  const { working_day } = validationSchemaForDirect;
  const workingDayHours = getWorkingDayHours(working_day);
  const timezone = originalTimes.pickup_timezone || moment.tz.guess();
  const now = moment().tz(timezone).clone();
  const todayFromDate = setTime(now, workingDayHours.from);
  const isForToday = now.isSameOrBefore(todayFromDate);
  const baseDate = isForToday
    ? now
    : setTime(now.add(1, 'days'), workingDayHours.from);

  const timeFrom = isForToday
    ? todayFromDate.format('HH:mm')
    : baseDate.format('HH:mm');
  const timeTo = setTime(baseDate, workingDayHours.to).format('HH:mm');

  const baseDateFormatted = baseDate.format('YYYY-MM-DD');

  // Add 1 margin hour for the pick up time needed (1 pallet)
  const dropoffTimeFrom = moment(timeFrom, 'HH:mm')
    .add(2, 'hour')
    .format('HH:mm');

  const dropoffTimeTo = moment(timeTo, 'HH:mm').add(1, 'hour').format('HH:mm');

  return {
    pickup_date_from: baseDateFormatted,
    pickup_date_to: baseDateFormatted,
    dropoff_date_from: baseDateFormatted,
    dropoff_date_to: baseDateFormatted,
    pickup_time_from: timeFrom,
    pickup_time_to: timeTo,
    dropoff_time_from: dropoffTimeFrom,
    dropoff_time_to: dropoffTimeTo,
    pickup_timezone: timezone,
    dropoff_timezone: timezone,
  };
};

function keyFromObjectHasEmptyValue(object) {
  const values = Object.values(object);

  return values.some((val) => !val);
}

export default {
  getTimeKeyFull,
  getTimeKey,
  getDateKey,
  getDateFromKey,
  getDateToKey,
  getDateKeys,
  getTimeKeysByStop,
  getAddressKey,
  getAddressRawKey,
  getGenericDefaultDates,
  getWorkingDayHours,
  keyFromObjectHasEmptyValue,
};
